/**
 * Labstep
 *
 * @module components/OrderRequest/Price
 * @desc Order Request price (currency and amoutn)
 */

import { OrderRequestFormShowEditAmount } from 'labstep-web/components/OrderRequest/Form/ShowEdit/Amount';
import { OrderRequestFormShowEditCurrency } from 'labstep-web/components/OrderRequest/Form/ShowEdit/Currency';
import type React from 'react';
import styles from './styles.module.scss';
import type { OrderRequestPriceProps } from './types';

export const OrderRequestPrice: React.FC<OrderRequestPriceProps> = ({
  orderRequest,
}) => (
  <div className={styles.price}>
    <OrderRequestFormShowEditCurrency orderRequest={orderRequest} />
    <OrderRequestFormShowEditAmount orderRequest={orderRequest} />
  </div>
);
